import { TPS_COMPONENT_CODE_SECTIONS,COO_COMPONENT_CODE_SECTIONS, TPSMEX_COMPONENT_CODE_SECTIONS, TPSMEX, TPSMEX_PARTS_SUBSECTIONS_ERR, ORIGIN_CRITERION_COMMENT_DEPS, SURVEYPART_SECTION_TYPES, SELF_SERVICE_QUE_TYPES_GENERIC, SELF_SERVICE_QUE_TYPES_PART, LBL_TEXT_HTML, LBL_BODYPARAGRAPH, LBL_BODY, TPS_AGREEMENT_DEPENDENCY} from "./surveyLiterals";
import { QUESTION_TYPES } from  "./constants";
import { ERR_QUESTION_LBL, ERR_QUESTION_STEP, ERR_SECTION_NAME, ERR_SECTION_STEP, ERR_TRANSLATION_REQ, ERR_SELECTION_TRANSLATION_REQ, ERR_SELECTION_REQ, ERR_SELECTION_TEXT, ERR_HELPDOC_REQ, ERR_NOTIFICATION_TEMPLATE, ERR_IS_MANDATORY, ERR_FIELD_NOT_REQ, ERR_SHOULD_HAVE_NUM, ERR_SHOULD_RESPOND_WITH, ERR_STATE_DD_DEPENDENCY, ERR_CHECK_POPUP_DEPENDENCY, ERR_AGREEMENT, ERR_TRANSLATION_COLUMNS } from "./errorLiterals";

export const getSectionsWithErrors = (form) => {
    const errors = []
    const valMap = new Map();
    //Loop by checkbox
    for (let i = 0; i < form.length; i++) {
        const elem = form[i];
        if(elem.type==='checkbox' && elem.checked){
            valMap.set(elem.getAttribute('name'),'');
        }
    }

    for (let i = 0; i < form.length; i++) {
        const elem = form[i];
        let elementName = elem.getAttribute('name');
        let elementId = elem.getAttribute('id');
        let section;
        if(elementName){
            section = elementName.split('-')[0].trim();    
        }else if(elementId){
            section = elementId.split('-').length>2 ? elementId.split('-')[1].trim() : null;
        }

        if(elem.type==='checkbox' && valMap.has(elementName)){
            continue;
        }else if(elem.type==='checkbox'){
            if(section && errors.findIndex(err => err  === section) < 0)
                errors.push(section);
        }
        if (!elem.validity.valid) {
            if(section && errors.findIndex(err => err  === section) < 0)
                errors.push(section);
        }
    }
    return errors;
}

export const validationOnCheckboxes = (checkboxes, errors) => {
    const map = new Map([]);
    checkboxes.forEach(check => {
        if (check.name && !check.getAttribute('checkedproprietary')) {
            if (map.has(check.name)) {
                if (!map.get(check.name)) {
                    map.set(check.name, check.checked)
                }
            }
            else {
                if(!check.getAttribute('checkedproprietary'))
                    map.set(check.name, check.checked)
            }
        }
    })
    map.forEach((checked, name) => {
        const array = name.split('-')
        if (!checked) {
            if(array[0] && errors.findIndex(err => err  === array[0]) < 0)
                errors.push(array[0]);
        }
    })
}

export const validateTier2Inputs = (form, tierSection) => {
    const indexes = []
    for (let i = 0; i < form.length; i++) {
        const elem = form[i];
        if (elem) {           
            let elementName = elem.getAttribute('name');
            let section;
            if(elementName)
                section = elementName.split('-')[0].trim();
            if(section && section === tierSection)
            {
                if(elem.type !== 'radio' && elem.type !== 'checkbox')
                    indexes.push(elementName.split('-')[1].trim());
            }           
        } 
       
    }
    const dataArr = new Set(indexes);
    let result = [...dataArr];

    if(result.length > 0){
        for(let j =0; j < result.length; j++){
            const name = tierSection + '-' + j;
            const elements = document.getElementsByName(name);
            const array = elements? Array.from(elements) : [];
            if(array){
                const req = array.find(e => e.value && e.value.trim().length > 0);
                if(req){
                    elements.forEach(e => {
                                            e.required = true;
                                            validateRequired(e,true);
                                        });
                }else
                {
                    elements.forEach(e => {
                                            e.required = false;
                                            validateRequired(e,false);
                                        });
                }

            }
        }
    }
}

const validateRequired = (element, req) => {
    if(element.value.trim() === ''){
        let lastValue = element.value;
        if(req)
            element.classList.add(".is-invalid");
        element.value = "";                                           
        let event = new Event("input", { target: element, bubbles: true });
        event.simulated = true;
        let tracker = element._valueTracker;
        if (tracker) {
            tracker.setValue(lastValue);
        } 
        element.dispatchEvent(event);     
    }
}

export const validatePartsAndSuppForCOO = ( suppliers, parts, errors, sections ) =>{
        if(suppliers.length<=0){
            const sectionTitle = sections.find(section => section.code === COO_COMPONENT_CODE_SECTIONS.SUPPLIERS_SEC)
            if(errors.findIndex(err => err  === sectionTitle.description) < 0 ){
                errors.push(sectionTitle.description)
            }   
        }else{
            if(parts.length<=0){
                const sectionTitle = sections.find(section => section.code === COO_COMPONENT_CODE_SECTIONS.PARTS_SECTIONS)
                if(errors.findIndex(err => err  === sectionTitle) < 0 ){
                    errors.push(sectionTitle.description)
                }  
            }
        }
    
    return errors
}

// Walks up the dependency chain; returns false if any link is not satisfied (prevents false errors on chained deps)
const getExpectedCheckDependencyAnswer = (idSelectionDependson) => {
  return idSelectionDependson !== null && idSelectionDependson !== undefined && idSelectionDependson.toString() === "0" ? "true" : "";
};

const isDependencyChainActive = (startQue, partQuestions, partAnswers, partId) => {
  let current = startQue;
  const visitedQuestionIds = new Set();
  while (current.idQuestionDepends && current.idQuestionDepends !== 0) {
    // Guard against cyclic dependency chains from misconfigured survey data.
    if (visitedQuestionIds.has(current.id)) return false;
    visitedQuestionIds.add(current.id);

    const parentQue = partQuestions.find((q) => q.id === current.idQuestionDepends);
    if (!parentQue) return false;
    const parentIdx = partAnswers.findIndex((ans) => ans.questionId == current.idQuestionDepends && ans.partId === partId);
    if (parentQue.type === QUESTION_TYPES.CHECK) {
      const parentAns = parentIdx === -1 || !partAnswers[parentIdx] || partAnswers[parentIdx].answer === "" ? "" : partAnswers[parentIdx].answer;
      const selDep = getExpectedCheckDependencyAnswer(current.idSelectionDependson);
      if (parentAns.trim() !== selDep) return false;
    } else {
      if (parentIdx === -1 || !partAnswers[parentIdx] || !partAnswers[parentIdx].answer) return false;
      const hasSelectionDependency = current.idSelectionDependson !== null && current.idSelectionDependson !== undefined && current.idSelectionDependson !== 0;
      if (hasSelectionDependency) {
        if (parentQue.type === QUESTION_TYPES.MULTI_SEL) {
          if (!partAnswers[parentIdx].answer.includes(current.idSelectionDependson.toString())) return false;
        } else {
          if (current.idSelectionDependson.toString() !== partAnswers[parentIdx].answer) return false;
        }
      }
    }
    current = parentQue;
  }
  return true;
};

export const valPartAndSuppSURVEYPART = (suppliers, partAnswers, errors, sections, partQuestionErrorIds, stateList) => {
    if (suppliers.length <= 0) {
      const supplierSection = sections.find((section) => section.type === SURVEYPART_SECTION_TYPES.SUPPLIER);
      if (errors.findIndex((err) => err === supplierSection.description) < 0) {
        errors.push(supplierSection.description);
      }
    } else {
      const partSections = sections.filter((section) => section.type === SURVEYPART_SECTION_TYPES.PART);
      const arrPartSectionErrors = [];
      for (const partSection of partSections) {
        const partQuestions = partSection.questions;
        const partIdsAnswered = new Set(partAnswers
          .filter(partAnswer => partQuestions.some(question => question.id === Number(partAnswer.questionId)))
          .map(part => part.partId));
        if (partIdsAnswered.size <= 0) {
          if (arrPartSectionErrors.findIndex((err) => err === partSection.description) < 0) {
            arrPartSectionErrors.push(partSection.description);
          }
        }
      }
      // Only add errors for part sections if *all* part sections have validation errors.
      // This prevents showing multiple errors when the root cause is that no parts have been answered at all.
      if (partSections.length === arrPartSectionErrors.length) {
        arrPartSectionErrors.forEach((sec) => errors.push(sec));
      } else {
        for (const partSection of partSections) {
          const partQuestions = partSection.questions;
          const partIdsAnswered = new Set(partAnswers
            .filter(partAnswer => partQuestions.some(question => question.id === Number(partAnswer.questionId)))
            .map(part => part.partId));
          partIdsAnswered.forEach((id) => {
            partQuestions.forEach((que) => {
              let skipValidationForThisPart = false;
              let isError = false;              
              if (que.idQuestionParent && que.idQuestionParent !== 0) {
                let index = partAnswers.findIndex((ans) => ans.questionId == que.idQuestionParent && ans.partId === id);
                if (index > -1 && partAnswers[index].answer && partAnswers[index].answer.toString() === "1") {
                  skipValidationForThisPart = true;
                }
              }
              if (!skipValidationForThisPart && que.idQuestionDepends && que.idQuestionDepends !== 0) {
                if (!isDependencyChainActive(que, partQuestions, partAnswers, id)) skipValidationForThisPart = true;
              }
              let selectionDependsOn_CHECK = "";
              let parentAns_CHECK = "";
              let parentIdx = partAnswers.findIndex((ans) => ans.questionId == que.idQuestionDepends && ans.partId === id);
              const parentQue = partQuestions.find((q) => q.id === que.idQuestionDepends);
              if (parentQue && parentQue.type === QUESTION_TYPES.CHECK) {
                selectionDependsOn_CHECK = getExpectedCheckDependencyAnswer(que.idSelectionDependson);
                parentAns_CHECK = parentIdx === -1 || partAnswers[parentIdx].answer === "" ? "" : partAnswers[parentIdx].answer;
              }
              if (!skipValidationForThisPart) {
                let index = partAnswers.findIndex((ans) => ans.questionId == que.id && ans.partId === id);
                let errMsg = null;
                if (que.required) { //If the question is marked as required
                  let isAnswerAvailable = false;
                  if (index === -1 || (index > -1 && !partAnswers[index].answer)) { //Answer is not available for this question
                    isError = true;
                    if (que.idQuestionDepends && que.idQuestionDepends !== 0) { //Checking various cases if the question is a dependent one
                      if (parentQue && parentQue.type === QUESTION_TYPES.CHECK) {
                        isError = parentAns_CHECK.trim() === selectionDependsOn_CHECK;
                      }
                      else if (parentQue && parentQue.type !== QUESTION_TYPES.MULTI_SEL && partAnswers[parentIdx] && partAnswers[parentIdx].answer.includes(que.idSelectionDependson.toString())) {
                        isError = true;
                      }
                      else if (parentIdx === -1 || (parentIdx > -1 && !partAnswers[parentIdx].answer)) isError = false;
                      else if (que.idSelectionDependson !== null && que.idSelectionDependson !== 0 && que.idSelectionDependson.toString() !== partAnswers[parentIdx].answer) {
                        isError = false;
                      }
                      else if (que.idSelectionDependson === 0 && que.type === QUESTION_TYPES.SEL_STATE) {
                        const arrStateList = stateList.find((s) => s.country === partAnswers[parentIdx].answer);
                        if (arrStateList && arrStateList.states && arrStateList.states.length === 0) isError = false;
                      }
                    }
                  } else {  //Answer is available for this question
                    isAnswerAvailable = true;
                    if (que.idQuestionDepends && que.idQuestionDepends !== 0) { //Checking various cases if the question is a dependent one
                      if (parentQue && parentQue.type === QUESTION_TYPES.CHECK) {
                        // Only error if parent="true" and the child answer is inconsistent
                        // If parent="false", no error even if child has data (dependency not active)
                        isError = false;
                      }
                      else if (parentIdx === -1 || (parentIdx > -1 && !partAnswers[parentIdx].answer)) {
                        // No parent response means dependency is not active - no error
                        isError = false
                      }
                      else if (parentQue.type !== QUESTION_TYPES.MULTI_SEL && que.idSelectionDependson !== null && que.idSelectionDependson !== 0 && que.idSelectionDependson.toString() === partAnswers[parentIdx].answer){
                        // Parent response matches dependency - data is valid
                        isError = false
                      }
                      else if (parentQue.type === QUESTION_TYPES.MULTI_SEL && que.idSelectionDependson !== null && que.idSelectionDependson !== 0 && partAnswers[parentIdx].answer.includes(que.idSelectionDependson.toString()) === true){
                        // Parent response includes dependency value - data is valid
                        isError = false
                      }
                      else {
                        // Parent response doesn't activate this dependency - no error for child data
                        isError = false
                      }
                    }
                  }
                  if (isError) {
                    errMsg = isAnswerAvailable ? `'${partSection.description}' - '${que.text}' ${ERR_FIELD_NOT_REQ}` : `'${partSection.description}' - '${que.text}' ${ERR_IS_MANDATORY}`;
                    let idx = partQuestionErrorIds.findIndex((pqe) => pqe.partId === id);
                    if (idx === -1) partQuestionErrorIds.push({ partId: id, errQueIds: [que.id] });
                    else partQuestionErrorIds[idx].errQueIds.push(que.id);
                  }
                } 
                if (!isError && index > -1 && que.type === QUESTION_TYPES.NUM) {
                  let validParameter = new RegExp(/[0-9]+([.][0-9]+)?$/);
                  if (!validParameter.test(partAnswers[index].answer)) {
                    isError = true;
                    errMsg = `'${partSection.description}' - '${que.text}' ${ERR_SHOULD_HAVE_NUM}`
                    let idx = partQuestionErrorIds.findIndex((pqe) => pqe.partId === id);
                    if (idx === -1) partQuestionErrorIds.push({ partId: id, errQueIds: [que.id] });
                    else partQuestionErrorIds[idx].errQueIds.push(que.id);
                  }
                }
                if (!isError) { // Custom validations for TPS Agreement Question with multiple selectionDependsOn values
                  const agreementQuesIndx = TPS_AGREEMENT_DEPENDENCY.findIndex((agr) => agr.queCode === que.code);
                  if (agreementQuesIndx > -1) {
                    let parentQueIndx = partQuestions.findIndex((que) => que.code === TPS_AGREEMENT_DEPENDENCY[agreementQuesIndx].questionDependsOn);
                    let parentAnsIndx = parentQueIndx ? partAnswers.findIndex((ans) => ans.questionId == partQuestions[parentQueIndx].id && ans.partId === id) : -1;
                    if (parentAnsIndx > -1 && partAnswers[parentAnsIndx].answer && partAnswers[parentAnsIndx].answer !== "") { // parent ans found and valid
                      if (TPS_AGREEMENT_DEPENDENCY[agreementQuesIndx].selectionDependsOn.includes(partAnswers[parentAnsIndx].answer)) { // parent ans is matching the child's selectionDependsOn
                        if (index === -1 || (index > -1 && !partAnswers[index].answer)) { // Child does not have a valid ans
                          errMsg = `'${partSection.description}' - '${que.text}' ${ERR_IS_MANDATORY}`
                          let idx = partQuestionErrorIds.findIndex((pqe) => pqe.partId === id);
                          if (idx === -1) partQuestionErrorIds.push({ partId: id, errQueIds: [que.id] });
                          else partQuestionErrorIds[idx].errQueIds.push(que.id);
                        }
                      } else {  // parent ans is not matching the child's selectionDependsOn
                        if (index > -1 && partAnswers[index].answer) { // Child has a valid ans
                          if (partAnswers[index].answer !== TPS_AGREEMENT_DEPENDENCY[agreementQuesIndx].childSelectionForced) {
                            const selection = que.selections.find((sel) => sel.value === TPS_AGREEMENT_DEPENDENCY[agreementQuesIndx].childSelectionForced);
                            errMsg = `'${partSection.description}' - '${que.text}' ${ERR_SHOULD_RESPOND_WITH} '${selection.text}'`
                            let idx = partQuestionErrorIds.findIndex((pqe) => pqe.partId === id);
                            if (idx === -1) partQuestionErrorIds.push({ partId: id, errQueIds: [que.id] });
                            else partQuestionErrorIds[idx].errQueIds.push(que.id);
                          }
                        }
                      }
                    }
                  }
                }
                if (errMsg && !errors.includes(errMsg)) {
                  errors.push(errMsg);
                }
              }
            });
          });
        }
      }
    }
  };  

export const validatePartsAndSupp = ( suppliers, parts, errors, sections, code ) =>{
    
        if(suppliers.length<=0){
            const sectionTitle = sections.find((section) => {
                return section.code === TPS_COMPONENT_CODE_SECTIONS.SUPPLIERS_SEC || section.code === TPSMEX_COMPONENT_CODE_SECTIONS.SUPPLIERS_SEC
            })
            if(errors.findIndex(err => err  === sectionTitle.description) < 0 ){
                errors.push(sectionTitle.description)
            }   
        }else{
            const sectionTitle = sections.find((section) => {
                return section.code === TPS_COMPONENT_CODE_SECTIONS.PARTS_SECTIONS || section.code === TPSMEX_COMPONENT_CODE_SECTIONS.PARTS_SECTIONS
            })
            if(parts.length<=0){
                if(errors.findIndex(err => err  === sectionTitle) < 0 ){
                    errors.push(sectionTitle.description)
                }  
            }else if(code === TPSMEX){
                let countryErr = false;
                let originErr = false;
                let commentsErr = false;
                for(let i=0; i<parts.length; i++){
                    if(!parts[i].country || parts[i].country.length === 0)   countryErr = true;
                    if(!parts[i].originCriterion || parts[i].originCriterion === "") originErr = true;
                    if(ORIGIN_CRITERION_COMMENT_DEPS.includes(parts[i].originCriterion) && (!parts[i].comments || parts[i].comments === ""))   commentsErr = true;
                    if(countryErr && originErr && commentsErr)  break;
                }
                if(countryErr)  errors.push(`${sectionTitle.description} - ${TPSMEX_PARTS_SUBSECTIONS_ERR.COUNTRY}`);
                if(originErr)  errors.push(`${sectionTitle.description} - ${TPSMEX_PARTS_SUBSECTIONS_ERR.ORIGIN}`);
                if(commentsErr)  errors.push(`${sectionTitle.description} - ${TPSMEX_PARTS_SUBSECTIONS_ERR.COMMENTS}`);
            }
        }    
    return errors
}

export const showInputTextErorr = (answers, questionId) => {
    let isError = false;
    let index = answers.findIndex(ans=> ans.questionId === questionId);
    let answer = index > -1 ? (typeof answers[index].answer === "string" ? answers[index].answer.trim() : answers[index].answer) : null;
    if(answer && answer !== ""){
        return isError;
    }else{
        return !isError;
    }
}

export const showTablesError = (suppliers,parts, isParts, surveyCode) => {
    let isError = false;
    if(!isParts){
        return suppliers.length<=0 ? !isError : isError
    }
    else if(surveyCode && surveyCode === TPSMEX){
        if(suppliers.length>0 && parts.length<=0){
            return !isError;
        }else if(suppliers.length>0 && parts.length>0){
            for(let i=0; i<parts.length; i++){
                if(!parts[i].country || parts[i].country.length === 0){
                    isError = true;
                    break;
                }
                else if(!parts[i].originCriterion || parts[i].originCriterion === ""){
                    isError = true;
                    break;
                }
                else if(ORIGIN_CRITERION_COMMENT_DEPS.includes(parts[i].originCriterion) && (!parts[i].comments || parts[i].comments === "")){
                    isError = true;
                    break;
                }
            }
        }
    }
    else{
        if(suppliers.length>0 && parts.length<=0){
            return !isError;
        }
    }
    return isError
}

export const validateDates = (sections, answers, errors, form) =>{
    
    sections.forEach( sec => {
        let questions = sec.questions
        let dateQuestions = questions.filter(q => q.type === "DATE");
        if(dateQuestions.length>1){
           let ans1 = answers.find(a => a.questionId === dateQuestions[0].id);
           let ans2 = answers.find(a => a.questionId === dateQuestions[1].id);
           let existInDOM1;
           let existInDOM2;  

          if(ans1 && ans2){
            existInDOM1 = findElementInDom(form, ans1.questionId);
            existInDOM2 = findElementInDom(form, ans2.questionId);
          }
           
          if(existInDOM1 && existInDOM2){
            let ansDate1 = new Date(ans1.answer);
            ansDate1.setHours(0,0,0,0);
            let ansDate2 = new Date(ans2.answer);
            ansDate2.setHours(0,0,0,0);

            if(dateQuestions[0].showOrder < dateQuestions[1].showOrder){
                if(new Date(ans2.answer).getTime() <= new Date(ans1.answer).getTime()){
                        errors.push(`${dateQuestions[1].text}  has to be greater than ${dateQuestions[0].text}`);
                }
            }else{
                if(new Date(ans1.answer).getTime() <= new Date(ans2.answer).getTime()){
                    errors.push(`${dateQuestions[0].text} has to be greater than ${dateQuestions[1].text}`);
                }
            }
          }

           
        }

    })
}



const findElementInDom = (form, elementId) => {
    let foundElement;

    for(let i = 0 ; i<form.length ; i++){
        if(form[i].id === elementId.toString()){
            foundElement = form[i];
        }
    }

    return foundElement;
}


export function validateDatePicker(form){
    const errors = new Map()
    if(form){
        let datePickerElements = document.getElementsByClassName('MuiInputBase-input MuiInputBase-inputAdornedStart css-1ve8hsq-MuiInputBase-input')
        if(datePickerElements){
            for(let i = 0; i < datePickerElements.length; i++){
                if(datePickerElements[i] && !datePickerElements[i].value){
                   errors.set(datePickerElements[i].name, datePickerElements[i].value)
                }
            }
        }
    }
    return errors
}

/*************************************************************Self Service Validations Start*************************************************************/

export const validateSurveyTitleTranslations = (survey) => {
  let isError = false;
  let errorMessage = "";
  if (survey.language.length > 1) {
    if (survey.translations.length !== survey.language.length - 1) {
      isError = true;
      errorMessage = ERR_TRANSLATION_REQ;
    }
    if (!isError) {
      isError = !survey.translations.every((t) => t.text && t.text.trim() !== "");
      errorMessage = isError ? ERR_TRANSLATION_REQ : "";
    }
  }
  return { show: isError, message: errorMessage };
};

export const validateAgreementStep = (survey) => {
  let isError = false;
  let errorMessage = "";
  if (survey.language.length > 1) {
    if (survey.agreementData.length > 0 && survey.agreementData.length !== survey.language.length) {
      isError = true;
      errorMessage = ERR_AGREEMENT;
    }
    if (!isError) {
      isError = !survey.agreementData.every((t) => t.text && t.text.trim() !== "");
      errorMessage = isError ? ERR_AGREEMENT : "";
    }
  }
  return { show: isError, message: errorMessage };
};

export const validateSectionStep = (survey, isPartTemplate) => {
    let isError = false;
    let errorMessage = "";
    if (survey.sections.length === 0) {
      isError = true;
      errorMessage = ERR_SECTION_STEP;
    } else {
      isError = !survey.sections.every((section) => section.description && section.description.trim() !== "");
      errorMessage = isError ? ERR_SECTION_NAME : "";
      //Checking Translations
      if (!isError && survey.language.length > 1) {
        for (let i = 0; i < survey.sections.length; i++) {
          if (!isPartTemplate && survey.sections[i].translations.length !== survey.language.length - 1) {
            isError = true;
            break;
          } else {
            const noneDefaultSectionIndex = survey.sections[i].type === SURVEYPART_SECTION_TYPES.RESPONSES || survey.sections[i].type === SURVEYPART_SECTION_TYPES.SUPPLIER  ? 1 : i;
            isError = isPartTemplate?
              !survey.sections[noneDefaultSectionIndex].translations.every((translation) => translation.text && translation.text.trim() !== "")
            :!survey.sections[i].translations.every((translation) => translation.text && translation.text.trim() !== "");
            if (!isError && survey.sections[i].longDescription && survey.sections[i].longDescription !== ""){
              isError = !survey.sections[i].translations.every((translation) => translation.longDescription && translation.longDescription.trim() !== "");
            }
            if (isError) break;
          }
        }
        errorMessage = isError ? ERR_TRANSLATION_REQ : "";
      }
    }
    return { show: isError, message: errorMessage };
};

export const validateDefaultColumns = (survey) => {
    let isError = false;
    let errorMessage = "";
    if (survey.language.length > 1) {
      isError = !survey?.defaultColumns?.every(col => 
        col?.translations?.length === survey.language.length - 1 &&
        col?.translations?.every(t => t.text?.trim())
      );
      errorMessage = isError ? ERR_TRANSLATION_COLUMNS : "";
    }
    return { show: isError, message: errorMessage };
};
  
export const validateQuestionStep = (survey) => {
    let isError = !survey.sections.every((section) => section.type === SURVEYPART_SECTION_TYPES.RESPONSES || section.type === SURVEYPART_SECTION_TYPES.SUPPLIER || section.questions.length > 0);
    let errorMessage = isError ? ERR_QUESTION_STEP : "";
    if (!isError) {
      const allQuestions = survey.sections.flatMap((section) => section.questions || []);
      for (let i = 0; i < survey.sections.length; i++) {
        const selfServiceQueTypes = survey.sections[i].type === SURVEYPART_SECTION_TYPES.PART ? SELF_SERVICE_QUE_TYPES_PART : SELF_SERVICE_QUE_TYPES_GENERIC;
        const questions = survey.sections[i].questions;
        isError = !questions.every((question) => question.text && question.text.trim() !== "");
        if (isError) {
          errorMessage = ERR_QUESTION_LBL;
          break;
        } else {
          for (let j = 0; j < questions.length; j++) {
            if (questions[j].type === QUESTION_TYPES.SEL_STATE && (!questions[j].codeQuestionDepends || questions[j].codeQuestionDepends === "")) {
              isError = true;
              break;
            }
          }
          errorMessage = isError ? ERR_STATE_DD_DEPENDENCY : "";
          if (!isError) {
            for (let j = 0; j < questions.length; j++) {
              const hasDependentQuestion = allQuestions.some((question) => question.codeQuestionDepends === questions[j].code);
              if (questions[j].type === QUESTION_TYPES.CHEK_POPUP && !hasDependentQuestion) {
                isError = true;
                break;
              }
            }
            errorMessage = isError ? ERR_CHECK_POPUP_DEPENDENCY : "";
          }
          if (!isError) {
            for (let j = 0; j < questions.length; j++) {
              const index = selfServiceQueTypes.findIndex((queTypes) => queTypes.code === questions[j].type);
              if (index > -1 && selfServiceQueTypes[index].needSelections && questions[j].selections.length === 0) {
                isError = true;
                break;
              }
            }
            errorMessage = isError ? ERR_SELECTION_REQ : "";
            if (!isError) {
              for (let j = 0; j < questions.length; j++) {
                const index = selfServiceQueTypes.findIndex((queTypes) => queTypes.code === questions[j].type);
                if (index > -1 && selfServiceQueTypes[index].needSelections) {
                  isError = !questions[j].selections.every((selection) => selection.text && selection.text.trim() !== "");
                }
                if (isError) {
                  errorMessage = ERR_SELECTION_TEXT;
                  break;
                }
              }
            }
          }
          //Checking Translations
          if (!isError && survey.language.length > 1) {
            for (let j = 0; j < questions.length; j++) {
              if (questions[j].translations.length !== survey.language.length - 1) isError = true;
              else isError = !questions[j].translations.every((translation) => translation.text && translation.text.trim() !== "");
              if (isError) {
                errorMessage = ERR_TRANSLATION_REQ;
                break;
              }
            }
          }
          //checking selection translation
          if (!isError && survey.language.length > 1) {
            for (let j = 0; j < questions.length; j++) {
              for(let s=0;s<questions[j].selections.length;s++){
                if(questions[j].selections[s].translations.length!== survey.language.length - 1) isError = true;
                else isError= !questions[j].selections[s].translations.every((translation) => translation.text && translation.text.trim() !== "");
                if (isError) {
                  errorMessage = ERR_SELECTION_TRANSLATION_REQ;
                  break;
                }
              }
            }
          }
          if (isError) break;
        }
      }
    }
    return { show: isError, message: errorMessage };
};

export const validateHelpDocs = (survey) => {
    let isError = true;
    let errorMessage = ERR_HELPDOC_REQ;
    //HelpDocs are generally optional but if its uploaded, it should be available for all languages
    if (survey.helpDocs.length === 0 || survey.helpDocs.length === survey.language.length) {
        isError = false;
        errorMessage = "";
    }
    return { show: isError, message: errorMessage };
};

export const validateSurveyNotification = (survey) => {
  let isError = false;
  let errorMessage = "";
  const parser = new DOMParser();
  const doc = parser.parseFromString(survey.surveyNotification, LBL_TEXT_HTML);
  const contents = doc.getElementsByClassName(LBL_BODYPARAGRAPH);
  for (let i = 0; i < contents.length; i++) {
    const index = survey.language.findIndex((sl) => `${LBL_BODY}${sl.text}` === contents[i].id);
    if (index > -1 && (!contents[i].innerHTML.trim() || contents[i].innerHTML.trim() === "")) {
      isError = true;
      errorMessage = ERR_NOTIFICATION_TEMPLATE;
    }
  }
  return { show: isError, message: errorMessage };
};

export const validateReportConfiguration = (survey) => {
  let isError = false;
  let errorMessage = "";
  
  // Only validate if report generation is enabled
  if (!survey?.reportConfiguration?.enableReportGeneration) {
    return { show: false, message: "" };
  }
  
  //Validate that at least one section is selected for report generation
  const reportConfig = survey?.reportConfiguration || {};
  const sectionsToInclude = reportConfig.sectionsToInclude || [];

  const includeSignatureSection = Boolean(reportConfig.includeSignatureSection);
  const includeDisclaimerSection = Boolean(reportConfig.includeDisclaimerSection);

  const hasAtLeastOneSection =
    sectionsToInclude.some((s) => Boolean(s.reportEnabled)) ||
    includeSignatureSection ||
    includeDisclaimerSection;

  if (!hasAtLeastOneSection) {
    return { show: true, message: "At least one section must be selected to enable report generation" };
  }

  if (includeDisclaimerSection) {
    const disclaimerMessage = String(reportConfig.disclaimerMessage ?? "").trim();
    if (disclaimerMessage === "") {
      return { show: true, message: "Disclaimer message is required when the disclaimer section is included." };
    }
  }

  const sectionMissingColumns = sectionsToInclude.filter((s) => s.reportEnabled && s.type === SURVEYPART_SECTION_TYPES.PART
    && Array.isArray(s.questionsToInclude)
    && s.questionsToInclude.length > 0
    && !s.questionsToInclude.some((q) => q.reportEnabled));

  if (sectionMissingColumns.length > 0) {
    return { show: true, message: `Section "${sectionMissingColumns[0].description || sectionMissingColumns[0].code}" has no questions selected for the report. Please select at least one question.` };
  }

  const partSectionEnabled = sectionsToInclude.some((s) => s.type === SURVEYPART_SECTION_TYPES.PART && s.reportEnabled);
  const questionFilters = partSectionEnabled ? (reportConfig.questionFilters || []) : [];
  const enabledFilters = questionFilters.filter((filter) => filter.enabled === true);

  for (const filter of enabledFilters) {
    // Check if operatorCode is set
    const hasOperatorCode = filter.operatorCode && String(filter.operatorCode).trim() !== "";
    if (!hasOperatorCode) {
      isError = true;
      errorMessage = `Filter "${filter.label || filter.questionCode || 'Unknown'}" is enabled but missing a condition. Please select a condition before saving.`;
      break;
    }

    // Check if value is set
    const filterValue = filter.value;
    const hasValue = Array.isArray(filterValue)
      ? filterValue.some((value) => String(value ?? "").trim() !== "")
      : filterValue !== undefined && filterValue !== null && String(filterValue).trim() !== "";
    if (!hasValue) {
      isError = true;
      errorMessage = `Filter "${filter.label || filter.questionCode || 'Unknown'}" is enabled but missing a value. Please enter or select a value before saving.`;
      break;
    }
  }

  return { show: isError, message: errorMessage };
};

export const validateSelfServiceSurvey = (survey, isPartTemplate) => {
    if (!survey || !survey.description || survey.description === "") return false;

    let error = validateSurveyTitleTranslations(survey);
    if (error.show) return false;

    error = validateAgreementStep(survey);
    if(error.show) return false;
    
    error = validateSectionStep(survey, isPartTemplate);
    if (error.show) return false;

    error = validateDefaultColumns(survey);
    if (error.show) return false;
    
    error = validateQuestionStep(survey);
    if (error.show) return false;

    error = validateHelpDocs(survey);
    if (error.show) return false;

    error = validateSurveyNotification(survey);
    if (error.show) return false;

    return true; // No errors found
};
  
  /*************************************************************Self Service Validations End*************************************************************/  